import React from "react";

export const Services = (props) => {
  const services = [...(props.data || [])].sort((a, b) => {
    const priority = (item) => item.name?.includes("AI-Agent") ? 0 : item.name?.includes("AI-Gateway") ? 1 : 2;
    return priority(a) - priority(b);
  });

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Delivery Foundation</h2>
          <p>
            Agent outcomes come first. Global model access and multi-cloud operations make them dependable in production.
          </p>
        </div>
        <div className="row">
          {services.length
            ? services.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className="col-md-4 service-anchor"
                  id={d.name?.includes("AI-Gateway") ? "llm-gateway" : d.name?.includes("AI-Infra") ? "cloud-infrastructure" : undefined}
                >
                  <span className="service-number">{String(i + 1).padStart(2, "0")}</span>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                    {d.links && (
                      <div className="service-links" aria-label={`${d.name} product links`}>
                        {d.links.map((link) => (
                          <a
                            key={link.label}
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {link.label}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
